import { Theme } from "@mui/material";
import chroma from "chroma-js";

export const positiveColorScale = chroma.scale("YlGn");
export const negativeColorScale = chroma.scale("OrRd");

export function countRadius(arr: number[], value: number): number {
  const maxRadius = 30;
  const minRadius = 5;
  const maxValue = arr.length === 0 ? -1 : Math.max.apply(null, arr);

  if (maxValue === 0) return minRadius;
  return (value * (maxRadius - minRadius)) / maxValue + minRadius;
}

export function getChangeColor(theme: Theme, isIncreased?: boolean | null): string {
  const { changeMarkers } = theme.palette;

  if (isIncreased === true) return changeMarkers.increased;
  if (isIncreased === false) return changeMarkers.decreased;
  return changeMarkers.unchanged;
}
